import ArrowLink from "components/components/ArrowLink/ArrowLink";
import SwaggerSingleRow from "components/dataVisualization/dataPageComponents/SwaggerSingleRow/SwaggerSingleRow";
import {
  Endpoint,
  I014TagValue,
} from "models/apiDocumentation/apiDocumentationModels";
import React from "react";
import { getEndpointDataByPath } from "utils/apiDocumentationUtils";
import featureFlags from "utils/featureFlags";
import routeConstants from "utils/routeConstants";

import { Link, SingleRowContainer } from "./style";

interface Props {
  linkSlug: string;
  getSwaggerSpec: (isNoSqlEndpoint: boolean) => string;
  apiEndpoints: Endpoint[];
}

const SingleEndpoint: React.FC<Props> = ({
  linkSlug,
  getSwaggerSpec,
  apiEndpoints,
}) => {
  const endpointData = getEndpointDataByPath(
    apiEndpoints,
    `/endpoint/${linkSlug}`
  );
  const isNoSqlEndpoint = endpointData?.tags.includes(I014TagValue) ?? false;

  return (
    <SingleRowContainer>
      <SwaggerSingleRow
        swaggerSpec={getSwaggerSpec(isNoSqlEndpoint)}
        endpointData={endpointData}
      />
      {featureFlags.rebrand ? (
        <ArrowLink
          to={`${routeConstants.apiDocs}/endpoint/${linkSlug}`}
          text="View in API documentation"
          isInternalDestination={true}
        />
      ) : (
        <Link href={`${routeConstants.apiDocs}/endpoint/${linkSlug}`}>
          View in API documentation
        </Link>
      )}
    </SingleRowContainer>
  );
};

export default SingleEndpoint;
